import React, { useEffect, useState } from 'react'
import Lottie from 'lottie-react'
import { useLottieLoader } from '@/hooks/utils/useLottieLoader'

import classes from './styles.module.scss'

const CROSSFADE_MS = 400

interface LottieAnimationProps {
  loop?: boolean
  autoplay?: boolean
  style?: React.CSSProperties
  lottieRef?: any
  lottiePath?: string
  animationData?: any
}

export const LottieAnimation: React.FC<LottieAnimationProps> = (props) => {
  const {
    loop = true,
    autoplay = true,
    style = {},
    lottieRef,
    lottiePath,
    animationData: externalAnimationData,
  } = props

  // Load animation from settings or custom path if no external data is provided
  const { animationData: loadedData } = useLottieLoader(
    externalAnimationData ? undefined : lottiePath
  )

  // Use external data if provided, otherwise use loaded data
  const animationData = externalAnimationData || loadedData

  // Crossfade when the animation source swaps mid-mount (e.g. the branded
  // lottie replacing the base one): keep the outgoing animation underneath
  // while the incoming one fades in, instead of blanking between fetches.
  const [current, setCurrent] = useState(animationData)
  const [previous, setPrevious] = useState<any>(null)
  if (animationData !== current) {
    setCurrent(animationData)
    setPrevious(current)
  }

  useEffect(() => {
    if (!previous) return
    const timer = setTimeout(() => setPrevious(null), CROSSFADE_MS)
    return () => clearTimeout(timer)
  }, [previous])

  if (!current) return null

  return (
    <div className={classes.crossfade}>
      {previous && (
        <div className={classes.outgoing}>
          <Lottie
            animationData={previous}
            loop={loop}
            style={style}
            autoplay={autoplay}
          />
        </div>
      )}
      <div className={previous ? classes.incoming : undefined}>
        <Lottie
          animationData={current}
          loop={loop}
          style={style}
          autoplay={autoplay}
          lottieRef={lottieRef}
        />
      </div>
    </div>
  )
}
